import React, { FC } from "react";
import { Grid, Stack } from "@mantine/core";
import dayjs from "dayjs";
import NumberFormatter from "@/components/atoms/NumberFormatter";
import Text from "@/components/atoms/Text";
import MatchStatusLabel from "@/components/molecules/MatchStatusLabel";
import { WeightReportLineDetails } from "@/types";
import { useTranslation } from "react-i18next";

interface WeightReportDetailsTabProps {
  /** The ID of the weight report line to display details for */
  selectedWeightLine: WeightReportLineDetails;
}

const WeightReportDetailsTab: FC<WeightReportDetailsTabProps> = ({ selectedWeightLine }) => {
  const { t } = useTranslation();

  return (
    <Stack>
      <Grid>
        <GridRow label={t("weightReports:columnsTranslation.customerName")} value={selectedWeightLine.customerName} />
        <GridRow label={t("product:product")} value={selectedWeightLine.article} />
        <GridRow
          label={t("weightReports:columnsTranslation.netWeight")}
          value={
            selectedWeightLine.netWeight ? (
              <NumberFormatter value={selectedWeightLine.netWeight} suffix={` ${selectedWeightLine.unit || ""}`} />
            ) : null
          }
        />
        <GridRow
          label={t("weightReports:columnsTranslation.weightDate")}
          value={selectedWeightLine.weightDate ? dayjs(selectedWeightLine.weightDate).format("DD.MM.YYYY") : null}
        />
        <GridRow label={t("weightReports:columnsTranslation.weightTime")} value={selectedWeightLine.weightTime} />
        <GridRow label={t("weightReports:columnsTranslation.truckNumber")} value={selectedWeightLine.truckNumber} />
        <GridRow label={t("weightReports:columnsTranslation.documentRef")} value={selectedWeightLine.documentRef} />
        <GridRow
          label={t("weightReports:columnsTranslation.matchedOrderId")}
          value={selectedWeightLine.matchedOrderId}
        />
        <GridRow
          label={t("weightReports:columnsTranslation.matchStatus")}
          value={<MatchStatusLabel status={selectedWeightLine.matchStatus} />}
        />
      </Grid>
    </Stack>
  );
};

export default WeightReportDetailsTab;

const GridRow = ({ label, value }: { label: string; value: string | React.ReactNode | null | undefined }) => {
  const isReactElement = React.isValidElement(value);

  return (
    <>
      <Grid.Col span={4}>
        <Text color="secondary" size="sm">
          {label}
        </Text>
      </Grid.Col>
      <Grid.Col span={8}>{isReactElement ? value : <Text size="sm">{value ?? "-"}</Text>}</Grid.Col>
    </>
  );
};

/**
 *
 *
 *             <Group align={"end"} gap={10} justify={""}>
 *               <Select
 *                 style={{ flex: 1 }}
 *                 label={
 *                    t(`weightReports:selectOrderToLinkLabel`, {
 *                 contractId: order.contractId,
 *                 productName: order.companySpecificProductDto?.companySpecificProductName ?? "",
 *                 estimatedAmount: order.amount,
 *                 unit: order.unit.unit,
 *                 createdDate: dayjs(order.created).format("DD.MM.YYYY"),
 *               })
 *                 }
 *                 loading={isLoadingOrders}
 *                 disabled={orders?.orders.length === 0}
 *                 data={orders?.orders?.map((order) => ({
 *                   value: order.id.toString(),
 *                   label:,
 *                 }))}
 *                 onChange={(value) => setSelectedOrderId(value)}
 *               />
 *             </Group>
 * **/
